import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ExploreRoutingModule } from './explore-routing.module';
import { ExploreComponent } from './pages/explore/explore.component';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../material.module';
import { RouterModule } from '@angular/router';
import { NgxsModule } from '@ngxs/store';
import { ExploreState } from './state/explore.state';
import { CategoriesComponent } from './pages/categories/categories.component';
import { BookmarksModule } from '../bookmarks/bookmarks.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SearchComponent } from './pages/search/search.component';
import { ExploreCardsComponent } from './components/explore-cards/explore-cards.component';
import { GalleryModule } from '../gallery/gallery.module';

@NgModule({
  imports: [
    NgxsModule.forFeature([
      ExploreState
    ]),

    SharedModule,
    MaterialModule,
    CommonModule,
    RouterModule,
    ExploreRoutingModule,
    BookmarksModule,
    FontAwesomeModule,
    GalleryModule
  ],
  declarations: [ExploreComponent, CategoriesComponent, SearchComponent, ExploreCardsComponent]
})
export class ExploreModule { }
